/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

/**
 * Component that is used for rendering Bookmaker Registration Panel
 */
function BookmakerRegPanel({ panelTemplate, isMobile }) {
    return (
        <div
            className={classNames(
                'rh-bookmaker-panel',
                {
                    'rh-bookmakers--mobile': isMobile
                }
            )}
            dangerouslySetInnerHTML={{ __html: panelTemplate[0] }}
        />
    );
}

BookmakerRegPanel.propTypes = {
    panelTemplate: PropTypes.arrayOf(
        PropTypes.string.isRequired
    ).isRequired,
    isMobile: PropTypes.bool
};

BookmakerRegPanel.defaultProps = {
    isMobile: false
};

const mapStateToProps = ({ panelTemplate }) => ({
    panelTemplate
});

const ConnectedBookmakerRegPanel = connect(mapStateToProps)(BookmakerRegPanel);

export {
    BookmakerRegPanel,
    ConnectedBookmakerRegPanel as default
};



// WEBPACK FOOTER //
// ./src/js/BookmakerRegPanel/BookmakerRegPanel.js